// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__iQDHl","doubleBounce1":"Spinner_doubleBounce1__NvPVV","doubleBounce2":"Spinner_doubleBounce2__3fncc","bounce":"Spinner_bounce__7L7VE"};